import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vimeo = defineConnector({
  identifier: "vimeo",
  name: "Vimeo",
  tagLine: "Video hosting and streaming",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://api\\.vimeo\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Vimeo app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Vimeo Developer Portal](https://developer.vimeo.com/apps) and click **Create an app**. Give it a name and description, then select the appropriate access level for your use case.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/vimeo/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Vimeo account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Vimeo account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.vimeo.com/oauth/authorize",
    tokenEndpoint: () => "https://api.vimeo.com/oauth/access_token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.vimeo.com/me",
  },
});
